import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentRoutingRoutingModule } from './payment-routing-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PaymentRoutingRoutingModule
  ]
})
export class PaymentRoutingModule { }
